<template>
    <div class="col-md-6 p-0 mr-5">
        <div class="calculator__step">
            <div class="calculator__step--top">
                <b>STORAGE CALCULATOR</b>
            </div>
            <div class="row m-0 calculator__step--content pl-4 pr-4 pt-4">
                <div class="col-md-3" style="color: #1D3354;">
                    <h3>Step 3</h3>
                    <p> Step 3 from 5 </p>
                </div>
                <div class="col-md">
                    <b-form-group>
                      <div class="row m-0 label pb-2">
                        <b>Historical Performance</b>
                        <div id="tooltip-1" class="more_info ml-1 __pointer">
                          <b>?</b>
                        </div>
                        <div class="__errorMsg text-left ml-2"> {{historical_message}} </div>
                          <b-tooltip target="tooltip-1"  placement="topright">
                           <p>Your company’s shipment performance based on the past shipment</p>
                        </b-tooltip>
                      </div>
                        <div class="row m-0">
                            <b-form-radio
                                class="mr-3"
                                v-model="form.historic"
                                v-for="(item, i) in optionsHistoric"
                                :key="i"
                                @change="historical_message = ''"
                                :value="item.value"
                                > {{item.text}} </b-form-radio>
                        </div>
                     </b-form-group>
                    <b-form-group>
                        <div class="row m-0 label pb-2">
                          <b>The Completeness of Document</b>
                          <div id="tooltip-2" class="more_info ml-1 __pointer">
                            <b>?</b>
                          </div>
                          <div class="__errorMsg text-left ml-2"> {{completeness_message}} </div>
                           <b-tooltip target="tooltip-2" placement="topright">
                            <p>Your company’s document availability for your desired shipment</p>
                          </b-tooltip>
                        </div>
                        <div  class="row m-0">
                            <b-form-radio
                                class="mr-3"
                                v-model="form.completeness"
                                v-for="(item, i) in optionsCompleteness"
                                :key="i"
                                @change="completeness_message = ''"
                                :value="item.value"
                                > {{item.text}} </b-form-radio>
                        </div>
                    </b-form-group>
                </div>
            </div>
            <div class="row m-0 calculator__step--bottom justify-content-end p-4 pt-5">
                <button class="_global__button--corporite pl-4 pr-4" @click="emitToParent('CalcStep2')">Back</button>
                <button class="_global__button--corporite pl-4 pr-4 ml-4" @click="emitToParent('CalcStep4')">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CalcStep3',
  data: () => ({
    historical_message: '',
    completeness_message: '',
    form: {
      stepName: '',
      historic: '',
      completeness: ''
    },
    optionsHistoric: [
      { text: 'Good', value: '3' },
      { text: 'Medium', value: '0' },
      { text: 'Bad', value: '-1' }
    ],
    optionsCompleteness: [
      { text: 'Yes', value: '3' },
      { text: 'No', value: '0' }
    ],
    payloadLog: {
      featureName: 'STORAGE CALCULATOR',
      featureStep: 3,
      stepName: 'Historical Performance, The Completeness of Document',
      featureProcess: {
        status: 'success',
        data: {}
      }
    }
  }),
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // insert log
      this.payloadLog.featureProcess.data = this.form
      this.$store.dispatch('log/CREATE_LOG', this.payloadLog)
    },
    emitToParent (data) {
      if (data === 'CalcStep2' || (this.form.historic && this.form.completeness)) {
        this.form.stepName = data
        this.$emit('activeForm', this.form)
      } else if (!this.form.historic && !this.form.completeness) {
        this.historical_message = 'This field is required*'
        this.completeness_message = 'This field is required*'
      } else if (!this.form.historic) {
        this.historical_message = 'This field is required*'
      } else { this.completeness_message = 'This field is required*' }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/storagecalculator/CalcStep3.vue